<template>
  <div class="version-data-menu common-slider" v-show="showSlider" :style="{ width: $MainWrap.sliderBox[0].boxWidth, top: $MainWrap.sliderTop }">
    <div class="slider-main">
      <a :href="'#' + item.id" class="summary-menu-each" v-for="(item, index) in $MainWrap.sideBarNavText" :key="index"
        :style="{ width: $MainWrap.sliderBox[0].itemWidth, height: $MainWrap.sliderBox[0].itemHeight }">
        <img :src="item.bgSrc" alt="">
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OfficialActiveSliderBar',
  components: {
  },
  props: {
  },
  // watch: {
  //   $route: {
  //     handler: function (newVal) {
  //       this.menuActiveIndex = newVal.hash
  //     },
  //     immediate: true
  //   }
  // },
  data() {
    return {
      menuActiveIndex: '#version-data-0',
      showSlider: false,
      container: null
    }
  },
  inject: ['$MainWrap'],
  async created() {
  },
  mounted() {
    // this.menuActiveIndex = window.location.hash
    const _this = this
    this.container = document.querySelector('#pageRenderParent') || window
    this.container.addEventListener('scroll', this.onScroll)

    // window.addEventListener('scroll', this.onScroll);
    // setTimeout(() => {
    //   window.addEventListener('scroll', () => {
    //     console.log(window.scrollY, '0-----0', _this.$MainWrap.sideBarNavShowDistance)
    //     if (window.scrollY > _this.$MainWrap.sideBarNavShowDistance) {
    //       _this.showSlider = true
    //     } else {
    //       _this.showSlider = false
    //     }
    //   })
    // }, 2000)
  },
  methods: {
    // kf(url) {
    //   window.open('https://www.wooduan.com/service/service/630ebde509187f8e02edde1d')
    // }
    _getScrollTop(e) {
      if (e.target.scrollTop !== undefined) {
        return e.target.scrollTop
      } else if (e.target.document) {
        return (
          e.target.document.documentElement.scrollTop ||
          window.pageYOffset ||
          e.target.document.body.scrollTop ||
          0
        )
      }
      return e.target.documentElement.scrollTop || e.target.body.scrollTop || 0
    },
    onScroll(e) {
      // console.log(this._getScrollTop(e))
      const scrollTop = this._getScrollTop(e)
      // console.log(this.$MainWrap.sideBarNavShowDistance, '111111', scrollTop)
      this.showSlider = scrollTop > this.$MainWrap.sideBarNavShowDistance
    }
  }
}
</script>

<style scoped lang="scss">
.retract-expand {
  font-size: 27px;
  margin-top: 10px;
  font-weight: 500;
  color: #FDEDC2;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.mini-color-btn {
  width: 100px;
  height: 25px;
  margin: 15px auto 0;
  cursor: pointer;
  font-size: 18px;
  text-align: center;
  line-height: 23px;
  border: 1PX solid;
  border-radius: 12px;
}

.slider-main {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-sizing: border-box;
  img {
    width: 100%;
    height: 100%;
  }
}

.version-data-menu {
  position: relative;
  box-sizing: border-box;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  //background-image: url("../../../../assets/images/versionActivity/slider/slider-bg.png");
  .summary-menu-each {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 45px;
    line-height: 45px;
    text-decoration: none;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-size: 24px;
    margin-bottom: 20px;
  }

  .isMenuActive {
    //background: url("../../../../assets/images/versionActivity/slider/choose-menu.png") no-repeat;
    background-size: 100% 100%;
    padding-left: 35px;
  }
}

.arrow-left {
  width: 25px;
  height: 25px;
  background-size: 100% 100%;
  display: flex;
  background-repeat: no-repeat;
  //background-image: url("../../../../assets/images/versionActivity/slider/arrow-left.png");
  margin-left: 15px;
}

.retract-expand {
  display: flex;
  justify-content: center;
}

.arrow-right {
  width: 25px;
  height: 25px;
  display: flex;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  //background-image: url("../../../../assets/images/versionActivity/slider/arrow-right.png");
  margin: 10px auto 0;
}

.show-slider {
  width: 112px;
  height: 221px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  //background-image: url("../../../../assets/images/versionActivity/slider/show-slider-bg.png");
  cursor: pointer;
}

.show-slider-text {
  font-size: 27px;
  font-weight: bold;
  color: #F7F1E4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
}

.common-slider {
  -webkit-transition: all linear 400ms;
  transition: all linear 400ms;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  z-index: 100;
}
</style>
